function track(...args: unknown[]) {
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('No GA tracking on dev...', args);
        return;
    }

    if (!(window as any).gtag) {
        return;
    }

    (window as any).gtag(...args);
}

function pageview(props: { pagePath: string }) {
    track('config', process.env.REACT_APP_GA_MEASUREMENT_ID, { page_path: props.pagePath });
}

function event(type: string, props: { [k: string]: string }) {
    track('event', type, props);
}

export default {
    pageview,
    event
};
